import React, { useContext } from 'react';
import { GlobalSiteDataContext } from '../../context';
import { ContactHero, SocialMedia, WaxingCostPerMonth, SEO } from '../../components';
import { graphql } from 'gatsby';
import './locations.css';

function ContactPage() {
    const siteData = useContext(GlobalSiteDataContext);
    return (
        <main id="contact-page">
            <ContactHero siteData={siteData} />
            <WaxingCostPerMonth />
            <SocialMedia currentMetro={siteData.currentMetro} />
        </main>
    );
}

export const Head = ({ data, location }) => {
    const query = data.siteDataJson;
    return (
        <SEO
            location={location}
            origin={query.origin}
            title={`Contact Laser Hair Removal in ${query.name}, ${query.stateAbbrev} | Milan Laser`}
            description="Have questions, comments, or concerns? Fill our our short form to contact a helpful customer service representative at Milan Laser."
            currentMetro={query}
        >
            <script src="https://embedsocial.com/cdn/ht.js" type="text/javascript" />
        </SEO>
    );
};

export const query = graphql`
    {
        siteDataJson {
            name
            stateAbbrev
            origin
            metroPath
            stores {
                pathname
                urlPath
            }
        }
    }
`;

export default ContactPage;
